// @ts-nocheck

import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlAssetsCustom } from "utils/common";

const PopupNoGift = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="popup-overlay modal-notify modal-fail">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="content-popup">
              <h5>
                <img src={urlAssetsCustom("assets/img/fail.png")} /> <br />
                Đăng ký thất bại...
              </h5>

              <p>
                Rất tiếc, mẫu đăng ký của bạn đã thất bại.
                <br />
                Vui lòng thử lại.
              </p>
            </div>
            <div className="btn-wrapper btn-center">
              <button
                type="button"
                onClick={() => {
                  navigate("/");
                  props.closeModal(false);
                }}
                className="btn btn-primary "
              >
                <a>QUAY LẠI TRANG CHỦ</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupNoGift;
